<template>
    <div class="container">
      <Head :showBorder="3" />
      <img class="regardWePic" src="../assets/regardWePic.jpg" alt="" />
      <div class="regardWePic1-div">
        <img class="regardWePic1" src="../assets/regardWePic1.jpg" alt="" />
      </div>
      <!-- <div class="regardWePic1-div">
        <img class="regardWePic2" src="../assets/regardWePic2.jpg" alt="" />
      </div> -->
      <Bottom/>
    </div>
  </template>
  
  <script>
  import Head from "@/view/module/head.vue";
  import Bottom from "@/view/module/bottom.vue";
  export default {
    name: "index",
    data() {
      return {};
    },
    components: {
      Head,
      Bottom
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .regardWePic2{
    width: 901px;
    /* height: 549px; */
    margin-bottom: 26px;
  }
  .regardWePic1-div{
    margin: auto;
  }
  .regardWePic{
    width: 100%;
    /* height: 747px; */
  }
  .regardWePic1{
    width: 100%;
    /* height: 1111px; */
  }
  </style>
  


// WEBPACK FOOTER //
// src/view/solution.vue